<template>
  <v-flex>
    <v-card>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Name'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
              v-model="name"
              class="ml-3 mr-3"
              label="Name"
              name="name"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader
            v-text="
              'Revenue % to donate (hint)'
            "
          ></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
              v-model="rev_sharing_pct"
              class="ml-3 mr-3"
              label="Revenue % to donate (hint)"
              name="rev_sharing_pct"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader
            v-text="
              'Address (ETH)'
            "
          ></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
              v-model="eth_address"
              class="ml-3 mr-3"
              label="Address (ETH)"
              name="eth_address"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader
            v-text="
              'Url'
            "
          ></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
              v-model="url"
              class="ml-3 mr-3"
              label="Url"
              name="url"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm12>
          <v-text-field
              v-model="description"
              class="ml-3 mr-3"
              label="Description"
              name="description"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-btn dark color="primary" @click="createCharity">
            Save
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import {mapGetters} from "vuex";

export default {
  name: "AddCharity",
  data: function() {
    return {
      name: "",
      rev_sharing_pct: "",
      eth_address: "",
      url: "",
      description: ""
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    })
  },
  methods: {
    async createCharity() {
      if (this.name.length) {
        const { data } = await axios.post("/api/v1/admin/charity/create", {
          name: this.name,
          rev_sharing_pct: this.rev_sharing_pct,
          eth_address: this.eth_address,
          url: this.url,
          description: this.description
        });

        if (data) {
          await swal({
            title: "Charity",
            text: "Charity added successfully",
            showCloseButton: true,
            imageUrl: "/img/popup_img_success.png",
            imageHeight: 80,
            imageWidth: 80,
            customClass: this.themeDark ? "swal-type-success-dark" : "swal-type-success",
          });
          window.location.reload();
        } else {
          await swal({
            title: "Charity",
            text: "Something went wrong! Please try again.",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/AddCharity.vue